import { watch } from 'vue'
import { useRoute } from 'vue-router'

/**
 * Централизованная загрузка деталей по route.params[paramName] с единым watcher'ом.
 * loader: (id: string|number) => Promise<void> | void
 * paramName: string = 'id'
 */
export function useLoadByRouteId(loader, paramName = 'id') {
    const route = useRoute()
    watch(
        () => route.params?.[paramName],
        (id, prev) => {
            if (id == null) return
            if (id === prev && prev != null) return
            loader(id)
        },
        { immediate: true }
    )
}